export const FETCH_PERSON_FAMILY_MEMBERS = 'FETCH_PERSON_FAMILY_MEMBERS';
export const FETCH_PERSON_FAMILY_MEMBERS_LOADING = 'FETCH_PERSON_FAMILY_MEMBERS_LOADING';
export const DELETE_PERSON_FAMILY_MEMBER = 'DELETE_PERSON_FAMILY_MEMBER';
export const ADD_PERSON_FAMILY_MEMBER = 'ADD_PERSON_FAMILY_MEMBER';
export const ADD_PERSON_FAMILY_MEMBER_LOADING = 'ADD_PERSON_FAMILY_MEMBER_LOADING';
export const RESET_ADD_PERSON_FAMILY_MEMBER_ACTION_RESULT =
  'RESET_ADD_PERSON_FAMILY_MEMBER_ACTION_RESULT';
